import React from 'react';
// ---- external imports ----

import bgImg from '~/assets/images/auth/bg.png';
import zigzagTopImg from '~/assets/images/auth/zigzag-top.png';
import zigzagBottomImg from '~/assets/images/auth/zigzag-bottom.png';
import Backdrop from '~/components/Backdrop';
import Asset from '~/containers/GameAsset/BaseAssets';
// ---- internal imports ----

const BACKDROP_SIZE = { width: 1920, height: 1080 };

const ZigzagTop = Asset.Img.withProjection(zigzagTopImg);
const ZigzagBottom = Asset.Img.withProjection(zigzagBottomImg);

function AuthBackdrop({ children }) {
	return (
		<Backdrop size={BACKDROP_SIZE} projection={bgImg}>
			<ZigzagTop x={40} y={40} shouldFadeIn={false} />
			<ZigzagBottom x={40} y={984} shouldFadeIn={false} />
			{children}
		</Backdrop>
	);
}

export default AuthBackdrop;
